module.exports = __webpack_public_path__ + "img/5.d1383355.png";